import React, { useState, useEffect, useRef } from "react";
import {
  useAuthErrorMessage,
  useAuthSuccessMessage,
  webAuth
} from "../utils/userJourneyHelper";

import styles from "./ForgotPassword.module.css";

function ForgotPassword() {
  const [formData, setFormData] = useState({
    email: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useAuthErrorMessage();
  const [successMessage, setSuccessMessage] = useAuthSuccessMessage();

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage();
    setError();
    webAuth.changePassword({
      connection: 'Username-Password-Authentication',
      email: formData.email
    }, function (err, resp) {
      setLoading(false)
      if(err){
        setError(err.message)
      }else{
        setSuccessMessage(resp)
      }
    })
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const el = useRef(null);

  useEffect(() => {
    if (error && el.current) {
      el.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [error]);

  return (
    <div className={styles.auth}>
      <span
        style={{
          boxSizing: "border-box",
          display: "inline-block",
          overflow: "hidden",
          width: "initial",
          height: "initial",
          background: "none",
          opacity: 1,
          border: "0px",
          margin: "0px",
          padding: "0px",
          position: "relative",
          maxWidth: "100%",
        }}
      >
        <span
          style={{
            boxSizing: "border-box",
            display: "block",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: "0px",
            margin: "0px",
            padding: "0px",
            maxWidth: "100%",
          }}
        >
          <img
            alt=""
            aria-hidden="true"
            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%271440%27%20height=%27899%27/%3e"
            style={{
              display: "block",
              maxWidth: "100%",
              width: "initial",
              height: "initial",
              background: "none",
              opacity: 1,
              border: "0px",
              margin: "0px",
              padding: "0px",
            }}
          />
        </span>
        <img
          alt=""
          srcSet="https://cdn.irishfunds.ie/1440x1800/8698c5e81d/bg-auth-image.jpeg/m/1440x0/filters:quality(80)?_w=1440 1x, https://cdn.irishfunds.ie/1440x1800/8698c5e81d/bg-auth-image.jpeg/m/1440x0/filters:quality(80)?_w=1440 2x"
          src="https://cdn.irishfunds.ie/1440x1800/8698c5e81d/bg-auth-image.jpeg/m/1440x0/filters:quality(80)?_w=1440"
          decoding="async"
          data-nimg="intrinsic"
          style={{
            position: "absolute",
            inset: "0px",
            boxSizing: "border-box",
            padding: "0px",
            border: "medium",
            margin: "auto",
            display: "block",
            width: "0px",
            height: "0px",
            minWidth: "100%",
            maxWidth: "100%",
            minHeight: "100%",
            maxHeight: "100%",
            objectFit: "cover",
          }}
        />
      </span>
      <section className={`${styles.auth_section} ${styles.forgotpassword} ${loading && styles.loading}`}>
        <div className={styles.header}>
          <svg
            role="presentation"
            viewBox="0 0 644 228"
            preserveAspectRatio="none"
            className={styles.shape}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.01758 -290.458L1006.94 473.78L1124.9 210.611L7.01758 -290.458Z"
              fill="#009247"
            ></path>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1125.6 209.059L-110.246 -28.8413L7.71373 -292.01L1125.6 209.059Z"
              fill="#3FAE48"
            ></path>
          </svg>
          <div className={styles.logo}>
            <span
              style={{
                boxSizing: "border-box",
                display: "inline-block",
                overflow: "hidden",
                width: "initial",
                height: "initial",
                background: "none",
                opacity: 1,
                border: 0,
                margin: 0,
                padding: 0,
                position: "relative",
                maxWidth: "100%",
              }}
            >
              <img
                alt=""
                aria-hidden="true"
                src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2772%27%20height=%2734%27/%3e"
                style={{
                  display: "block",
                  maxWidth: "100%",
                  width: "initial",
                  height: "initial",
                  background: "none",
                  opacity: 1,
                  border: "0px",
                  margin: "0px",
                  padding: "0px",
                }}
              />
            </span>
            <img
              alt="Irish Funds Logo"
              srcSet="/assets/img/IFlogo-white-small.png?_w=72 1x, /assets/img/IFlogo-white-small.png?_w=72 2x"
              src="/assets/img/IFlogo-white-small.png?_w=72"
              decoding="async"
              data-nimg="intrinsic"
              style={{
                position: "absolute",
                inset: "0px",
                boxSizing: "border-box",
                padding: "0px",
                border: "medium",
                margin: "auto",
                display: "block",
                width: "0px",
                height: "0px",
                minWidth: "100%",
                maxWidth: "100%",
                minHeight: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
        <form className={styles.forgotpasswordForm} ref={el} onSubmit={submitHandler}>
          <h1 className={styles.heading}>Reset Password</h1>
          <p className={styles.description}>
            Enter your email address below to receive an email with instructions
            on how to reset your password.
          </p>
          {error && <p className={styles.error}>Error: {error}</p>}
          {successMessage && <p className={styles.success}>{successMessage}</p>}
          <div className={styles.fields}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              name="email"
              required
              placeholder="Email"
              onChange={handleChange}
            />
            <div
              data-lastpass-icon-root=""
              style={{
                position: "relative !important",
                height: "0px !important",
                width: "0px !important",
                float: "left !important",
              }}
            ></div>
            <button
              type="submit"
              className={`${styles.forgotButton} ${styles.forgotButton_secondary}`}
            >
              Reset Password
            </button>
            <p className={styles.back}>
              <a href="/Auth/Login/">Back to login</a>
            </p>
          </div>
        </form>
      </section>
    </div>
  );
}

export default ForgotPassword;
